const css = `.pVw5CW__enter{opacity:0}.pVw5CW__enterActive{opacity:1;transition:opacity .5s cubic-bezier(.3,1,.32,1)}.pVw5CW__exit{opacity:1;pointer-events:none}.pVw5CW__exitActive{opacity:0;pointer-events:none;transition:opacity .5s cubic-bezier(.3,1,.32,1)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"enterActive":"pVw5CW__enterActive","enter":"pVw5CW__enter","exitActive":"pVw5CW__exitActive","exit":"pVw5CW__exit"};
